import { useState } from 'react';

export enum Step {
  Input,
  Confirm,
  Done,
}

export const useStep = (initialStep: Step = Step.Input) => {
  const [step, setStep] = useState<Step>(initialStep);

  const stepTo = {
    input: () => {
      // 入力画面に戻る場合はhashでスクロールされるため、ここでは制御しない
      setStep(Step.Input);
    },
    confirm: () => {
      setStep(Step.Confirm);
      window.scrollTo(0, 0);
    },
    done: () => {
      setStep(Step.Done);
      window.scrollTo(0, 0);
    },
  };

  return { step, stepTo };
};
